import { AuthService } from './../service/auth.service';
import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-home-mobileapp',
  templateUrl: './home-mobileapp.component.html',
  styleUrls: ['./home-mobileapp.component.css'],
})
export class HomeMobileappComponent implements OnInit {

  image: File;
  mobileappForm: FormGroup;
  downloadURL: Observable<string>;
  FOLDER: any = 'home/';
  loading: any = false;
  homeimgurl: any = '';
  edit: any = false;
  id: any;
  error: any = '';
  oldimage: any;
  homepagedata:any=[];
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private auth: AuthService,
    public toastr: ToastsManager,vcr: ViewContainerRef) { 
      this.toastr.setRootViewContainerRef(vcr);
    }

  ngOnInit() {
    this.mobileappForm = this.form.group({
      title: ['', [Validators.required]],
      heading_web: ['', [Validators.required]],
      ShowHidePremium:['',[]],
      ShowHideUpcomingReleases:['true',[]],
      ShowHideOnGoingSeries:['true',[]],
      ShowHideStreakHistory:['true',[]],
      upload_Image: ['', []]
    });
    this.checkdata();
  }
  async checkdata() {
    try {
      const homedata = await this.afs.collection('/HomePage').valueChanges();
      homedata.subscribe(homepagedata => {
        console.log(homepagedata);
        this.homepagedata = homepagedata;
        if (homepagedata.length >= 1) {
          this.mobileappForm.get('title').setValue(homepagedata[0]['heading']);
          this.mobileappForm.get('ShowHidePremium').setValue(String(homepagedata[0]['ShowHidePremium']));
          this.mobileappForm.get('ShowHideUpcomingReleases').setValue(String(homepagedata[0]['ShowHideUpcomingReleases']));
          this.mobileappForm.get('ShowHideOnGoingSeries').setValue(String(homepagedata[0]['ShowHideOnGoingSeries']));
          this.mobileappForm.get('ShowHideStreakHistory').setValue(String(homepagedata[0]['ShowHideStreakHistory'] ? homepagedata[0]['ShowHideStreakHistory'] : 'true'));
          this.mobileappForm.get('heading_web').setValue(homepagedata[0]['heading_web']);
          this.oldimage = homepagedata[0]['imageurl'];
          this.homeimgurl = homepagedata[0]['imageurl'];
          this.edit = true;
          this.id = homepagedata[0]['id'];
        }
      });
    } catch (error) {
      this.error = 'Somthing went wrong please try later';
      this.toastr.error('Somthing went wrong please try later', 'Oops!');
      console.log(error);
    }
  }

  changeListner2(event) {
    if (event.target.files && event.target.files[0]) {
      this.image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.homeimgurl = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  async addhomepage(value, valid) {
    this.error = '';
    console.log(value,valid)
    if (valid || this.edit) {
      this.loading = true;
      try {
        let uploadedimage;
        if (this.edit) {
          if (this.image) {
            uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
            await this.afs.doc('HomePage/' + this.id).update({ heading: value.title,ShowHidePremium:JSON.parse(value.ShowHidePremium),ShowHideUpcomingReleases:JSON.parse(value.ShowHideUpcomingReleases),ShowHideOnGoingSeries:JSON.parse(value.ShowHideOnGoingSeries),ShowHideStreakHistory:JSON.parse(value.ShowHideStreakHistory),heading_web:value.heading_web, imageurl: uploadedimage['Location']});
          } else {
            await this.afs.doc('HomePage/' + this.id).update({ heading: value.title,ShowHidePremium:JSON.parse(value.ShowHidePremium),ShowHideUpcomingReleases:JSON.parse(value.ShowHideUpcomingReleases),ShowHideOnGoingSeries:JSON.parse(value.ShowHideOnGoingSeries),ShowHideStreakHistory:JSON.parse(value.ShowHideStreakHistory),heading_web:value.heading_web });
          }
        } else {
          if(!this.image){
          this.error = 'Image is required';
          this.toastr.error('Image is required!', 'Oops!');
          }
          uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
          const addhomepage = await this.afs.collection('HomePage')
          .add({ heading: value.title, imageurl: uploadedimage['Location'], type: 'mobile',ShowHidePremium:JSON.parse(value.ShowHidePremium),ShowHideUpcomingReleases:JSON.parse(value.ShowHideUpcomingReleases),ShowHideOnGoingSeries:JSON.parse(value.ShowHideOnGoingSeries),ShowHideStreakHistory:JSON.parse(value.ShowHideStreakHistory),heading_web:value.heading_web, });
          const id = addhomepage.id;
          await this.afs.doc(`/HomePage/${id}`).update({id: id});
        }
        this.loading = false;
        this.toastr.success('Mobileapp Home Updated !', 'Success!');
      } catch (error) {
        this.loading = false;
        this.toastr.error('Somthing went wrong please try later!', 'Oops!');
        console.log(error);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home-mobileapp/home-mobileapp.component.ts